import OrigenDeudaDelete from './OrigenDeudaDelete'
export {OrigenDeudaDelete}
export default OrigenDeudaDelete
